export default "__VITE_ASSET__BcYUarYC__"